<template>
  <div
    class="status-bar"
    :style="{
      background: bgColor,
      height: height + 'px',
    }"
  ></div>
</template>
<script>

export default {
  props: {
    bgColor: {
      type: String,
      default: "#000",
    },
    height: {
      default: 0,
    },
  },
};
</script>
<style scoped lang="less">
.status-bar {
  width: 100vw;
  z-index: 9888;
  // height: 24px;
}
</style>
